import EditProject from "./edit-project";

export default EditProject;
